import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import CustomModal from '../UI/Modals/CustomModal'
import Paragraph from '../UI/Texts/Paragraph'
import { CircularProgress } from '@material-ui/core'
import WarningIcon from '@material-ui/icons/Warning'
import './styles.css'

const PedidoPagoPendiente = ({
  classes,
  openModalPagoPendiente,
  handleOnClickEntendido,
  timeExceeded,
}) => {
  useEffect(() => {
    console.log("PedidoPagoPendiente props:", { openModalPagoPendiente, timeExceeded });
  }, [openModalPagoPendiente, timeExceeded]);
  return <CustomModal
    open={openModalPagoPendiente}
    onClose={() => { }}
    hideCloseButton={true}
    title={timeExceeded ? (
      <>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <WarningIcon style={{ color: '#FFC107', marginRight: 8 }} />
          PAGO PENDIENTE
        </div>
      </>
    ) : (
      <>
        <div>
          Espere un momento...
        </div>
      </>
    )}
    buttonNames={timeExceeded ? ["ENTENDIDO"] : []}
    buttonActions={timeExceeded ? [handleOnClickEntendido] : []}
    showCloseButton={false}
  >
    <div className={timeExceeded ? "modalTextContent" : "modalTextContentLoading"}>
        {timeExceeded ? (
          <>
          <div style={{marginBottom: '10px'}}>
            <Paragraph size="big" weight="regular">
              Tu pago aún está siendo procesado por el medio de pago seleccionado.
            </Paragraph>
          </div>
          <div>
            <Paragraph size="big" weight="regular">
              Te notificaremos por correo electrónico apenas tengamos novedades.
            </Paragraph>
            </div>
          </>
        ) : (
          <>
            <div className="loaderContainer" style={{ marginTop: '20px' , marginBottom: '10px' }}>
              <CircularProgress size={50} />
            </div>
          </>
        )}
      </div>
    </CustomModal>
}


PedidoPagoPendiente.propTypes = {
  classes: PropTypes.string.isRequired,
  openModalPagoPendiente: PropTypes.bool.isRequired,
  handleOnClickEntendido: PropTypes.func.isRequired,
  timeExceeded: PropTypes.bool.isRequired
}

export default PedidoPagoPendiente;